import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import Menu from "@mui/material/Menu";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import ProjectRecording from "assets/images/icons/ProjectRecording.png";
import FileDownload from "assets/images/icons/File_Download.png";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import UploadIcon from "@mui/icons-material/CloudUpload";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Icon from "@mui/material/Icon";
import DeleteIcon from "@mui/icons-material/Delete";
import CalendarIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlineOutlined";
import Send from "@mui/icons-material/Send";
import NearMeIcon from "@mui/icons-material/NearMe";
import CheckIcon from "@mui/icons-material/Check";
import IconButton from "@mui/material/IconButton";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import colors from "assets/theme/base/colors";
import { UserContext } from "context";
import CircularProgress from "@mui/material/CircularProgress";
import { useNotification } from "context/NotificationContext";
import { DropzoneDialog } from "material-ui-dropzone";

import permissionLogo from "assets/images/icons/Permission.png";
import FileDownloadV2 from "assets/images/icons/File_DownloadV2.png";
import FileUploadV2 from "assets/images/icons/File_UploadV2.png";

const { grey, badgeColors, gradients } = colors;
const apiUrl = process.env.REACT_APP_AUTH_API_URL;

function Permission() {
  const { user: loggedInUser } = useContext(UserContext);
  const [userId, setUserId] = useState(null);
  const { eventId, permissionId } = useParams();
  const [isEditingStatus, setIsEditingStatus] = useState(false);
  const [status, setStatus] = useState("");
  const [isEditingAdmin, setIsEditingAdmin] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState("Non impostato");
  const adminTextRef = useRef(null);
  const [anchorAdmin, setAnchorAdmin] = useState(null);
  const [eventDetails, setEventDetails] = useState(null);
  const [permissionDetails, setPermissionDetails] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [uploadingDoc, setUploadingDoc] = useState(null);
  const [openValidateDialog, setOpenValidateDialog] = useState(false);
  const [validateDoc, setvalidateDoc] = useState(null);
  const [rejectionNotes, setRejectionNotes] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [addLoading, setAddLoading] = useState(false);
  const [validateLoading, setValidateLoading] = useState(false);
  const [error, setError] = useState(null);
  const [newDocumentSign, setNewDocumentSign] = useState({ name: "", expiry_date: "", file: null, link_to_sign: "" });
  const { showNotification } = useNotification();

  const [validationErrors, setValidationErrors] = useState({
    name: false,
    expiry_date: false,
    file: false,
  });

  const [newDocumentPayment, setNewDocumentPayment] = useState({
    name: "",
    expiry_date: "",
    file: null,
  });
  const [newDocumentRequired, setNewDocumentRequired] = useState({
    name: "",
    expiry_date: "",
    file: null,
  });

  const [docsSign, setDocsSign] = useState([]);
  const [docsPayment, setDocsPayment] = useState([]);
  const [docsRequired, setDocsRequired] = useState([]);
  const [docsPermission, setDocsPermission] = useState([]);
  const [dragging, setDragging] = useState(false);
  const [editingExpiryDate, setEditingExpiryDate] = useState(null);
  const [newExpiryDate, setNewExpiryDate] = useState("");
  const [editingLinkToSign, setEditingLinkToSign] = useState(null);
  const [newLinkToSign, setNewLinkToSign] = useState("");

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const eventResponse = await fetch(`${apiUrl}/event/event_details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ eventId }),
        });
        const eventData = await eventResponse.json();
        if (eventData.message) {
          setError(eventData.message);
        } else {
          setEventDetails(eventData);
        }

        const permissionResponse = await fetch(`${apiUrl}/permission/permission_details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ eventId, permissionId }),
        });
        const permissionData = await permissionResponse.json();
        if (permissionData.message) {
          setError(permissionData.message);
        } else {
          setStatus(permissionData.status);
          const adminName = permissionData.admin_name ? permissionData.admin_name : "Non impostato";
          const adminSurname = permissionData.admin_surname ? permissionData.admin_surname : "";

          setSelectedAdmin(`${adminName} ${adminSurname}`.trim());
          setPermissionDetails(permissionData);
          setUserId(permissionData.user_id);

          // Fetch documents concurrently
          const docPromises = permissionData.permissionDocuments.map(async (doc) => {
            const adminDocResponse = await fetch(`${apiUrl}/file_list.php`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                user_id: permissionData.user_id,
                path: doc.type + "/" + doc.doc_id + "/admin",
              }),
            });
            const adminDocResult = await adminDocResponse.json();
            doc.file = adminDocResult.message.files[0];

            const userDocResponse = await fetch(`${apiUrl}/file_list.php`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                user_id: permissionData.user_id,
                path: doc.type + "/" + doc.doc_id + "/user",
              }),
            });
            const userDocResult = await userDocResponse.json();
            doc.userFile = userDocResult.message.files[0];

            const permissionDocResponse = await fetch(`${apiUrl}/file_list.php`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                user_id: permissionData.user_id,
                path: "Permission" + "/" + permissionData.permission_multiselect_id,
              }),
            });
            const permissionDocResult = await permissionDocResponse.json();
            doc.permissionFile = permissionDocResult.message.files[0];
            setDocsPermission(doc.permissionFile);
            return doc;
          });

          const documents = await Promise.all(docPromises);

          setDocsSign(documents.filter((doc) => doc.type === "Sign"));
          setDocsPayment(documents.filter((doc) => doc.type === "Payment"));
          setDocsRequired(documents.filter((doc) => doc.type === "Required"));
        }
      } catch (error) {
        setError(error.message);
      } finally {
        fetchAdmins();
        setLoading(false);
      }
    };

    fetchDetails();
  }, [eventId, permissionId]);

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const saveStatus = async () => {
    try {
      console.log(status);
      const response = await fetch(`${apiUrl}/permission/update_status.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: permissionDetails.permission_multiselect_id, status: status }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setIsEditingStatus(false);
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const file = event.dataTransfer.files[0]; // Get dropped file
    if (file) handleUpload({ target: { files: [file] } }); // Pass it to handleUpload
  };

  const handleAdminClick = () => {
    setAnchorAdmin(adminTextRef.current);
  };

  const handleCloseMenu = () => {
    setAnchorAdmin(null);
  };

  const fetchAdmins = async () => {
    try {
      const response = await fetch(`${apiUrl}/event/admins.php`);
      const admins = await response.json();
      setAdminList(admins);
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  const handleAdminChange = async (newAdmin) => {
    setSelectedAdmin(newAdmin.name + " " + newAdmin.surname);
    await saveAdmin(newAdmin);
    handleCloseMenu();
  };

  const saveAdmin = async (admin) => {
    try {
      const adminId = admin ? admin.id : null;

      const response = await fetch(`${apiUrl}/permission/update_admin.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: permissionDetails.permission_multiselect_id,
          admin_id: adminId,
          event_id: eventId,
        }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setIsEditingAdmin(false);
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Error updating admin:", error);
    }
  };

  const handleExpiryDateClick = (docId, currentDate) => {
    if (loggedInUser.isAdmin) {
      setEditingExpiryDate(docId);
      setNewExpiryDate(currentDate);
    }
  };

  const handleExpiryDateSave = async (docId, docType) => {
    try {
      const response = await fetch(`${apiUrl}/permission/update_expiry_date.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          doc_id: docId,
          expiry_date: newExpiryDate,
        }),
      });
      const result = await response.json();
      if (result.status === "success") {
        // Update local state
        const updateDocument = (docs) =>
          docs.map((doc) =>
            doc.doc_id === docId ? { ...doc, expiry_date: newExpiryDate } : doc
          );
        
        setDocsSign((prevDocs) => updateDocument(prevDocs));
        setDocsPayment((prevDocs) => updateDocument(prevDocs));
        setDocsRequired((prevDocs) => updateDocument(prevDocs));
        
        setEditingExpiryDate(null);
        showNotification("success", "Data di scadenza aggiornata con successo!");
      } else {
        showNotification("error", "Errore nell'aggiornamento della data di scadenza");
      }
    } catch (error) {
      console.error("Error updating expiry date:", error);
      showNotification("error", "Errore nell'aggiornamento della data di scadenza");
    }
  };

  const handleLinkToSignClick = (docId, currentLink) => {
    if (loggedInUser.isAdmin) {
      setEditingLinkToSign(docId);
      setNewLinkToSign(currentLink || "");
    }
  };

  const handleLinkToSignSave = async (docId) => {
    try {
      const response = await fetch(`${apiUrl}/permission/update_link_to_sign.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          doc_id: docId,
          link_to_sign: newLinkToSign,
        }),
      });
      const result = await response.json();
      if (result.status === "success") {
        // Update local state
        const updateDocument = (docs) =>
          docs.map((doc) =>
            doc.doc_id === docId ? { ...doc, link_to_sign: newLinkToSign } : doc
          );
        
        setDocsSign((prevDocs) => updateDocument(prevDocs));
        
        setEditingLinkToSign(null);
        showNotification({
          color: "success",
          icon: <CheckIcon />,
          title: "Successo",
          dateTime: new Date().toLocaleString(),
          content: "Link alla firma aggiornato con successo!",
        });
      } else {
        showNotification({
          color: "error",
          icon: <Icon>error</Icon>,
          title: "Errore",
          dateTime: new Date().toLocaleString(),
          content: "Errore nell'aggiornamento del link alla firma",
        });
      }
    } catch (error) {
      console.error("Error updating link to sign:", error);
      showNotification({
        color: "error",
        icon: <Icon>error</Icon>,
        title: "Errore",
        dateTime: new Date().toLocaleString(),
        content: "Errore nell'aggiornamento del link alla firma",
      });
      showNotification("error", "Errore nell'aggiornamento della data di scadenza");
    }
  };

  const finalizePermission = async () => {
    try {
      const response = await fetch(`${apiUrl}/permission/send_permission_email.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event_name: eventDetails.event.event_name,
          permission_name: permissionDetails.permission_name,
          email: permissionDetails.user_email,
        }),
      });
      const data = await response.json();
      if (response.ok) {
      } else {
        alert("Email Failed" + data.message);
      }
    } catch (error) {
      console.error("Error emailing the user:", error);
    }
  };

  const handleValidateButton = (doc) => {
    setvalidateDoc(doc);
    setRejectionNotes("");
    setOpenValidateDialog(true);
  };

  const handleValidateConfirm = async (confirmed, overrideDocId = null) => {
    setValidateLoading(true);
    try {
      const response = await fetch(`${apiUrl}/permission/update_validation.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          validation: confirmed,
          doc_id: overrideDocId || validateDoc.doc_id, // Use overrideDocId if present, otherwise use validateDoc.doc_id
          email: permissionDetails.user_email,
          notes: confirmed === "-1" ? rejectionNotes : "",
        }),
      });

      const result = await response.json();
      if (result.status === "success") {
        if (validateDoc) {
          const updateDocument = (docs) =>
            docs.map((doc) => {
              if (doc.name === validateDoc.name) {
                // Delete file when invalidating (validation = -1)
                if (confirmed === "-1") {
                  deleteFile(doc.type, doc.doc_id, doc.userFile, false);
                  return { ...doc, validation: confirmed, userFile: null };
                }
                return { ...doc, validation: confirmed };
              }
              return doc;
            });

          setDocsSign((prevDocs) => updateDocument(prevDocs));
          setDocsPayment((prevDocs) => updateDocument(prevDocs));
          setDocsRequired((prevDocs) => updateDocument(prevDocs));
        }

        setOpenValidateDialog(false);
        setValidateLoading(false);
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Error updating admin:", error);
    }
  };

  const handleDeleteDocument = async () => {
    if (!validateDoc) {
      showNotification({
        color: "error",
        icon: <Icon>error</Icon>,
        title: "Errore",
        content: "Nessun documento selezionato per l'eliminazione.",
      });
      return;
    }

    setValidateLoading(true);

    try {
      let fileUrl;
      fileUrl = `${validateDoc.type}/${validateDoc.doc_id}/user/${validateDoc.userFile}`;
      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("path", fileUrl);

      const response = await fetch(`${apiUrl}/file_delete.php`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (result.message === "File or directory deleted successfully.") {
        // Remove the document from the corresponding state (UI)
        const updateDocument = (docs) =>
          docs.map((doc) => {
            if (doc.doc_id === validateDoc.doc_id) {
              return {
                ...doc,
                userFile: null,
              };
            }
            return doc;
          });
        setDocsSign((prevDocs) => updateDocument(prevDocs));
        setDocsPayment((prevDocs) => updateDocument(prevDocs));
        setDocsRequired((prevDocs) => updateDocument(prevDocs));

        // Show a success notification in Italian
        showNotification({
          color: "success",
          icon: <Icon>check_circle</Icon>,
          title: "Successo",
          content: "Documento eliminato con successo.",
        });
      } else {
        // Handle deletion error in Italian
        console.error(result.message);
        showNotification({
          color: "error",
          icon: <Icon>error</Icon>,
          title: "Errore",
          content: "Eliminazione del documento fallita: " + result.message,
        });
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      showNotification({
        color: "error",
        icon: <Icon>error</Icon>,
        title: "Errore",
        content: "Si è verificato un errore durante l'eliminazione del documento.",
      });
    } finally {
      // Stop loading state after deletion
      setValidateLoading(false);
      setOpenValidateDialog(false);
    }
  };

  const handleUploadButton = (doc) => {
    setUploadingDoc(doc);
    setOpenDialog(true);
  };

  const handleUpload = (event) => {
    setUploadedFile(event.target.files[0]);
  };

  const handleUploadConfirm = async () => {
    if (uploadingDoc) {
      const updateDocument = (docs) =>
        docs.map((doc) =>
          doc.name === uploadingDoc.name ? { ...doc, userFile: uploadedFile.name } : doc
        );

      const formData = new FormData();
      if (uploadingDoc !== "permission") {
        formData.append("path", uploadingDoc.type + "/" + uploadingDoc.doc_id + "/user");
      } else {
        formData.append("path", "Permission" + "/" + permissionDetails.permission_multiselect_id);
      }
      formData.append("user_id", userId || loggedInUser.id);
      formData.append("file[]", uploadedFile);
      try {
        const response = await fetch(`${apiUrl}/file_upload.php`, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          // Send email notification to admin
          if (uploadingDoc !== "permission") {
            try {
              const notifyResponse = await fetch(`${apiUrl}/permission/notify_document_upload.php`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  eventId: eventId,
                  permissionId: permissionId,
                  docId: uploadingDoc.doc_id,
                  fileName: uploadedFile.name,
                }),
              });
              const notifyResult = await notifyResponse.json();
              console.log("Email notification result:", notifyResult);
              if (!notifyResponse.ok) {
                console.error("Failed to send notification email:", notifyResult);
              }
            } catch (emailError) {
              console.error("Error sending notification email:", emailError);
            }
          }
        } else {
          alert("File upload failed: " + data.message);
          return;
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
      if (uploadingDoc !== "permission") {
        setDocsSign((prevDocs) => updateDocument(prevDocs));
        setDocsPayment((prevDocs) => updateDocument(prevDocs));
        setDocsRequired((prevDocs) => updateDocument(prevDocs));
      } else {
        setDocsPermission(uploadedFile.name);
        finalizePermission();
      }
    }
    setOpenDialog(false);
    setUploadedFile(null);
  };

  const downloadFile = (type, documentId, file, admin) => {
    if (type === "Permission") {
      var url = `${apiUrl}/uploads/${userId}/${type}/${permissionDetails.permission_multiselect_id}/${file}`;
    } else if (admin) {
      var url = `${apiUrl}/uploads/${userId}/${type}/${documentId}/admin/${file}`;
    } else {
      var url = `${apiUrl}/uploads/${userId}/${type}/${documentId}/user/${file}`;
    }
    window.open(url, "_blank");
  };

  const deleteFile = async (type, documentId, file, admin) => {
    let fileUrl;
    if (type === "Permission") {
      fileUrl = `${type}/${permissionDetails.permission_multiselect_id}/${file}`;
    } else if (admin) {
      fileUrl = `${type}/${documentId}/admin/${file}`;
    } else {
      fileUrl = `${type}/${documentId}/user/${file}`;
    }
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("path", fileUrl);

    await fetch(`${apiUrl}/file_delete.php`, {
      method: "POST",
      body: formData,
    });
  };

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <div>Loading...</div>
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <div>Error: {error}</div>
      </DashboardLayout>
    );
  }

  const { event } = eventDetails;
  const renderDocumentSection = (
    title,
    subtitle,
    type,
    documents,
    newDocument,
    setNewDocument,
    setDocumentState
  ) => {
    const handleAddDocument = async () => {
      setAddLoading(true);
      // Validation check to ensure all inputs are filled
      if (
        !newDocument.name ||
        !newDocument.expiry_date ||
        (!newDocument.file && title !== "Documenti Richiesti")
      ) {
        showNotification({
          color: "error",
          icon: <Icon>error</Icon>,
          title: "Errore",
          dateTime: new Date().toLocaleString(),
          content: "Please fill in all the fields before adding the document.",
        });
        const errors = {
          name: !newDocument.name,
          expiry_date: !newDocument.expiry_date,
          file: !newDocument.file,
        };
        setAddLoading(false);
        setValidationErrors(errors);
        return;
      }
      // Proceed with the fetch request if validation passes
      const response = await fetch(`${apiUrl}/permission/add_document.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          permissionId: permissionDetails.permission_multiselect_id,
          type: type,
          name: newDocument.name,
          expiry_date: newDocument.expiry_date,
          email: permissionDetails.user_email,
          link_to_sign: newDocument.link_to_sign || null,
        }),
      });

      const result = await response.json();
      if (result.status === "success") {
        if (title !== "Documenti Richiesti") {
          const formData = new FormData();
          formData.append("path", `${type}/${result.documentId}/admin`);
          formData.append("user_id", userId || loggedInUser.id);
          formData.append("file[]", newDocument.file);

          try {
            const response = await fetch(`${apiUrl}/file_upload.php`, {
              method: "POST",
              body: formData,
            });
            const data = await response.json();
            if (response.ok) {
              // Refresh the existing file info after upload
            } else {
              alert("File upload failed: " + data.message);
            }
          } catch (error) {
            console.error("Error uploading file:", error);
          }
        }
        // Add the new document to the list and reset the input fields
        documents.push({
          ...newDocument,
          doc_id: result.documentId,
          type: type,
          id: result.documentId,
          userFile: null,
          validation: false,
        });
        setNewDocument({ name: "", expiry_date: "", file: null, link_to_sign: "" });
      } else if (result.status === "exists") {
        console.error(result.message);
      } else {
        console.error(result.message);
      }
      setAddLoading(false);
    };

    const handleDocumentChange = (field, value) => {
      setNewDocument((prev) => ({
        ...prev,
        [field]: value,
      }));
    };

    return (
      <MDBox mt={0}>
        <MDTypography color="text" fontWeight="bold" variant="h4">
          {title}
        </MDTypography>
        {loggedInUser.isAdmin && (
          <MDTypography color="text" variant="h6" fontWeight="regular" mb={1}>
            {subtitle}
          </MDTypography>
        )}

        {loggedInUser.isAdmin && (
          <MDBox my={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={type === "Sign" ? 2 : 3}>
                <MDBox
                  sx={{
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  <MDInput
                    type="text"
                    placeholder="Nome documento..."
                    value={newDocument.name}
                    onChange={(e) => handleDocumentChange("name", e.target.value)}
                    style={{
                      width: "100%",
                      border: "none",
                      borderRadius: "4px",
                      background: "transparent",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <MDBox
                  sx={{
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  <MDInput
                    type="date"
                    value={newDocument.expiry_date}
                    onChange={(e) => handleDocumentChange("expiry_date", e.target.value)}
                    style={{
                      width: "100%",
                      borderRadius: "4px",
                      border: "none",
                      background: "transparent",
                    }}
                  />
                </MDBox>
              </Grid>
              {title === "Documenti Richiesti" ? undefined : (
                <Grid item xs={12} sm={6} md={type === "Sign" ? 2 : 4}>
                  <MDBox
                    sx={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <MDInput
                      type="file"
                      onChange={(e) => handleDocumentChange("file", e.target.files[0])}
                      style={{
                        width: "100%",
                        border: "none",
                        background: "transparent",
                      }}
                    />
                  </MDBox>
                </Grid>
              )}
              {type === "Sign" && (
                <Grid item xs={12} sm={6} md={4}>
                  <MDBox
                    sx={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <MDInput
                      type="text"
                      placeholder="Link per firma..."
                      value={newDocument.link_to_sign || ""}
                      onChange={(e) => handleDocumentChange("link_to_sign", e.target.value)}
                      style={{
                        width: "100%",
                        border: "none",
                        borderRadius: "4px",
                        background: "transparent",
                      }}
                    />
                  </MDBox>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                sm={6}
                md={2}
                sx={{
                  display: { sm: "block" },
                  justifyContent: { xs: "center" },
                }}
              >
                {addLoading ? (
                  <CircularProgress />
                ) : (
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      backgroundColor: "#2C2C2C",
                      borderRadius: "8px",
                      cursor: "pointer",
                      "&:hover": {
                        boxShadow: `0px 6px 8px 0px ${"rgba(128, 128, 128, 0.3)"}`,
                      },
                    }}
                    onClick={handleAddDocument}
                  >
                    <NearMeIcon color="primary" sx={{ transform: "scale(1.5)", mx: 1 }} />
                    <MDTypography
                      m={1}
                      color="white"
                      variant="h6"
                      fontWeight="medium"
                      textTransform="capitalize"
                    >
                      Invia
                    </MDTypography>
                  </MDBox>
                )}
              </Grid>
            </Grid>
          </MDBox>
        )}

        {documents.length === 0 ? (
          <MDBox
            sx={{
              textAlign: "center",
              backgroundColor: grey[100],
              border: "4px solid",
              borderColor: grey[300],
              borderRadius: "4px",
              padding: "16px",
              width: {
                xs: "100%",
                md: "50%",
              },
              margin: "0 auto",
            }}
          >
            <MDTypography sx={{ color: grey[500] }} variant="h6">
              Non ci sono documenti da caricare
            </MDTypography>
          </MDBox>
        ) : (
          <MDBox
            sx={{
              overflowX: "auto", // Enables horizontal scrolling
              width: "100%",
            }}
          >
            <Grid container spacing={3} sx={{ minWidth: "1000px" }}>
              {" "}
              {/* Ensures the Grid items do not collapse on smaller screens */}
              <Grid item xs={3}>
                <MDTypography color="text" variant="h6" fontWeight="bold" sx={{ fontSize: "1rem" }}>
                  Nome documento
                </MDTypography>
              </Grid>
              <Grid item xs={3}>
                <MDTypography color="text" variant="h6" fontWeight="bold" sx={{ fontSize: "1rem" }}>
                  Data Scadenza
                </MDTypography>
              </Grid>
              {title === "Documenti Richiesti" ? undefined : (
                <Grid item xs={1.5}>
                  <MDTypography
                    color="text"
                    variant="h6"
                    fontWeight="bold"
                    sx={{ fontSize: "1rem" }}
                  >
                    File Permessi
                  </MDTypography>
                </Grid>
              )}
              <Grid item xs={1.5}>
                <MDTypography color="text" variant="h6" fontWeight="bold" sx={{ fontSize: "1rem" }}>
                  File Utente
                </MDTypography>
              </Grid>
              <Grid item xs={3}>
                <MDTypography color="text" variant="h6" fontWeight="bold" sx={{ fontSize: "1rem" }}>
                  Azione
                </MDTypography>
              </Grid>
              {title === "Documenti Richiesti" ? <Grid item xs={1.5} /> : undefined}
              {documents.map((doc, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={3}>
                    <MDBox
                      sx={{
                        textAlign: "center",
                        border: "1px solid",
                        borderColor: grey[300],
                        borderRadius: "8px",
                        padding: "6px",
                      }}
                    >
                      <MDTypography color="text" fontWeight="500">
                        {doc.name}
                      </MDTypography>
                    </MDBox>
                  </Grid>
                  <Grid item xs={3}>
                    {loggedInUser.isAdmin && editingExpiryDate === doc.doc_id ? (
                      <MDBox
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <MDInput
                          type="date"
                          value={newExpiryDate}
                          onChange={(e) => setNewExpiryDate(e.target.value)}
                          sx={{ flex: 1 }}
                        />
                        <IconButton
                          size="small"
                          onClick={() => handleExpiryDateSave(doc.doc_id, doc.type)}
                          sx={{ color: "success.main" }}
                        >
                          <CheckIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => setEditingExpiryDate(null)}
                          sx={{ color: "error.main" }}
                        >
                          <Icon fontSize="small">close</Icon>
                        </IconButton>
                      </MDBox>
                    ) : (
                      <MDBox
                        sx={{
                          textAlign: "center",
                          border: "1px solid",
                          borderColor:
                            new Date(doc.expiry_date) < new Date()
                              ? gradients.error.main
                              : grey[300],
                          borderRadius: "8px",
                          padding: "6px",
                          cursor: loggedInUser.isAdmin ? "pointer" : "default",
                          "&:hover": loggedInUser.isAdmin
                            ? {
                                backgroundColor: grey[100],
                              }
                            : {},
                        }}
                        onClick={() => handleExpiryDateClick(doc.doc_id, doc.expiry_date)}
                      >
                        <MDTypography color="text" fontWeight="bold">
                          {new Date(doc.expiry_date).toLocaleDateString()}
                        </MDTypography>
                      </MDBox>
                    )}
                  </Grid>
                  {doc.file && (
                    <Grid
                      item
                      xs={1.5}
                      sx={{
                        userSelect: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <MDBox
                        component="img"
                        src={FileDownload}
                        alt="NewRequest"
                        width="60px"
                        my={-4}
                        sx={{
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          downloadFile(doc.type, doc.doc_id, doc.file.name || doc.file, true)
                        }
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={1.5}
                    sx={{
                      userSelect: "none",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {doc.userFile ? (
                      <MDBox
                        component="img"
                        src={FileDownload}
                        alt="NewRequest"
                        width="60px"
                        my={-4}
                        sx={{
                          cursor: "pointer",
                        }}
                        onClick={() => downloadFile(doc.type, doc.doc_id, doc.userFile, false)}
                      />
                    ) : (
                      <MDBox
                        sx={{
                          textAlign: "center",
                          border: "1px solid",
                          borderColor: grey[300],
                          borderRadius: "8px",
                          padding: "16px",
                        }}
                      >
                        <MDTypography
                          color="text"
                          variant="h5"
                          fontWeight="bold"
                          sx={{ fontSize: "1rem" }}
                        >
                          N/A
                        </MDTypography>
                      </MDBox>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <MDBox
                      sx={{
                        textAlign: "center",
                        padding: "8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      {loggedInUser.isAdmin && editingLinkToSign === doc.doc_id && type === "Sign" ? (
                        <MDBox
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <MDInput
                            type="text"
                            placeholder="Link per firma..."
                            value={newLinkToSign}
                            onChange={(e) => setNewLinkToSign(e.target.value)}
                            sx={{ flex: 1 }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => handleLinkToSignSave(doc.doc_id)}
                            sx={{ color: "success.main" }}
                          >
                            <CheckIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => setEditingLinkToSign(null)}
                            sx={{ color: "error.main" }}
                          >
                            <Icon fontSize="small">close</Icon>
                          </IconButton>
                        </MDBox>
                      ) : (
                        <>
                          {doc.link_to_sign && (
                            <MDBox sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                              <MDButton
                                variant="outlined"
                                color="info"
                                size="small"
                                startIcon={<Icon>edit</Icon>}
                                onClick={() => window.open(doc.link_to_sign, "_blank")}
                                sx={{ flex: 1 }}
                              >
                                Firma
                              </MDButton>
                              {loggedInUser.isAdmin && type === "Sign" && (
                                <IconButton
                                  size="small"
                                  onClick={() => handleLinkToSignClick(doc.doc_id, doc.link_to_sign)}
                                  sx={{ color: "primary.main" }}
                                  title="Modifica link alla firma"
                                >
                                  <Icon fontSize="small">settings</Icon>
                                </IconButton>
                              )}
                            </MDBox>
                          )}
                          {!doc.link_to_sign && loggedInUser.isAdmin && type === "Sign" && (
                            <MDButton
                              variant="outlined"
                              color="secondary"
                              size="small"
                              startIcon={<Icon>add_link</Icon>}
                              onClick={() => handleLinkToSignClick(doc.doc_id, "")}
                            >
                              Link
                            </MDButton>
                          )}
                        </>
                      )}
                      {doc.validation === "1" ? (
                        <MDButton variant="contained" color="primary" size="small" startIcon={<CheckIcon />}>
                          Validato
                        </MDButton>
                      ) : doc.userFile ? (
                        loggedInUser.isAdmin ? (
                          <MDButton
                            variant="contained"
                            color="warning"
                            size="small"
                            startIcon={<FindInPageIcon />}
                            onClick={() => handleValidateButton(doc)}
                          >
                            Valida
                          </MDButton>
                        ) : (
                          <MDButton
                            variant="contained"
                            color="warning"
                            size="small"
                            startIcon={<FindInPageIcon />}
                          >
                            In attesa
                          </MDButton>
                        )
                      ) : (
                        <MDButton
                          variant="contained"
                          color="secondary"
                          size="small"
                          startIcon={<UploadIcon />}
                          onClick={() => handleUploadButton(doc)}
                        >
                          Carica
                        </MDButton>
                      )}
                    </MDBox>
                  </Grid>
                  {!doc.file && <Grid item xs={1.5} />}
                </React.Fragment>
              ))}
            </Grid>
          </MDBox>
        )}
      </MDBox>
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1} pb={7}>
        <Card>
          <MDBox
            mx={2}
            mt={-10}
            py={3}
            px={2}
            variant="gradient"
            sx={{
              background: "linear-gradient(90deg, #14181F, #6E8ED1, #3A496A)",
            }}
            borderRadius="xl"
            coloredShadow="info"
          >
            <MDBox display="flex" flexDirection="column">
              <MDTypography
                fontWeight="bold"
                display="inline"
                variant="h1"
                color="white"
                sx={{
                  fontSize: {
                    xs: "1.5rem",
                    sm: "1.8rem",
                    md: "2rem",
                    lg: "2.5rem",
                  },
                }}
              >
                {permissionDetails.permission_name}
              </MDTypography>
              <MDTypography
                variant="h3"
                display="inline"
                fontWeight="700"
                sx={{
                  fontSize: {
                    xs: "1rem",
                    sm: "1.1rem",
                    md: "1.2rem",
                    lg: "1.4rem",
                  },
                  color: "rgb(255,255,255,77%)",
                }}
              >
                {event.event_name}
              </MDTypography>
            </MDBox>
            {isEditingStatus ? (
              <>
                <Select placeholder={status} value={status} onChange={handleStatusChange} autoWidth>
                  <MenuItem value="In lavorazione">In lavorazione</MenuItem>
                  <MenuItem value="Azione Richiesta">Azione Richiesta</MenuItem>
                  <MenuItem value="In attesa del permesso">In attesa del permesso</MenuItem>
                  <MenuItem value="Completo">Completo</MenuItem>
                </Select>
                <IconButton onClick={saveStatus}>
                  <CheckIcon />
                </IconButton>
              </>
            ) : (
              <MDTypography
                variant="h5"
                display="inline"
                fontWeight="light"
                sx={{
                  fontSize: {
                    xs: "1rem",
                    sm: "1.1rem",
                    md: "1.2rem",
                    lg: "1.4rem",
                  },
                  color: "rgb(255,255,255,77%)",
                }}
              >
                {status}{" "}
                {loggedInUser.isAdmin && (
                  <Icon onClick={() => setIsEditingStatus(true)} sx={{ cursor: "pointer" }}>
                    edit
                  </Icon>
                )}
              </MDTypography>
            )}
          </MDBox>
          <MDBox mx={3} my={4}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={5}>
                <MDBox>
                  <MDBox display="flex" mb={2}>
                    <CalendarIcon color="text" sx={{ mr: 2, mt: 1, transform: "scale(1.3)" }} />
                    <MDBox>
                      <MDTypography color="text" fontWeight="bold" variant="h4">
                        <span style={{ fontWeight: "bold" }}>
                          {new Date(event.created).toLocaleDateString().replace(/\./g, "/")}
                        </span>
                      </MDTypography>
                      <MDTypography color="text" fontWeight="light" variant="h6">
                        Data creazione
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  {loggedInUser.isAdmin && (
                    <MDBox display="flex" mb={2}>
                      <PersonIcon color="text" sx={{ mr: 1, mt: 1, transform: "scale(1.5)" }} />
                      <MDBox>
                        <MDBox display="flex" alignItems="center">
                          <MDTypography
                            ref={adminTextRef}
                            color="text"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                              cursor: loggedInUser.isAdmin ? "pointer" : "default",
                            }}
                            mr={1}
                            variant="h4"
                            fontWeight="bold"
                            onClick={loggedInUser.isAdmin ? handleAdminClick : null}
                          >
                            {selectedAdmin}
                          </MDTypography>
                          {loggedInUser.isAdmin && (
                            <>
                              <Icon
                                color="text"
                                onClick={handleAdminClick}
                                sx={{ cursor: "pointer" }}
                              >
                                edit
                              </Icon>
                              <Menu
                                anchorEl={anchorAdmin}
                                open={Boolean(anchorAdmin)}
                                onClose={handleCloseMenu}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "left",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                              >
                                {adminList.map((admin) => (
                                  <MenuItem onClick={() => handleAdminChange(admin)} key={admin.id}>
                                    {`${admin.name} ${admin.surname}`}
                                  </MenuItem>
                                ))}
                              </Menu>
                            </>
                          )}
                        </MDBox>
                        <MDTypography color="text" fontWeight="light" variant="h6">
                          Assegnato
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  )}
                </MDBox>
              </Grid>

              <Grid item xs={12} md={6} lg={5}>
                <MDBox
                  sx={{
                    position: "relative",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <Card
                    sx={{
                      boxShadow: 0,
                      border: 1,
                      borderColor: "#D3D3D3",
                      backgroundColor: "light",
                    }}
                  >
                    <MDBox m={1.5}>
                      <MDTypography fontWeight="medium" mb={0.5} color="text">
                        Informazioni Utene
                      </MDTypography>
                      <MDTypography
                        fontWeight="medium"
                        color="secondary"
                        variant="h6"
                        sx={{ lineHeight: "170%" }}
                      >
                        {event.user_company}
                      </MDTypography>
                      <MDTypography
                        fontWeight="light"
                        color="text"
                        variant="h6"
                        sx={{ lineHeight: "140%" }}
                      >
                        {event.user_name}, {event.user_surname}
                      </MDTypography>
                      <MDTypography
                        fontWeight="light"
                        color="text"
                        variant="h6"
                        sx={{ lineHeight: "140%" }}
                      >
                        {event.user_street}
                      </MDTypography>
                      <MDTypography
                        fontWeight="light"
                        color="text"
                        variant="h6"
                        sx={{ lineHeight: "140%" }}
                      >
                        {event.user_city}
                      </MDTypography>
                      <MDTypography
                        fontWeight="light"
                        color="text"
                        variant="h6"
                        sx={{ lineHeight: "140%" }}
                      >
                        {event.user_phone}
                      </MDTypography>
                    </MDBox>
                  </Card>
                  {loggedInUser.isAdmin && (
                    <MDButton
                      variant="contained"
                      component="a"
                      color="black"
                      href={`tel:${event.user_phone}`}
                      sx={{
                        backgroundColor: "#2C2C2C",
                        position: "absolute",
                        bottom: 16,
                        right: 16,
                        borderRadius: "8px",
                      }}
                    >
                      Chiama
                    </MDButton>
                  )}
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
      <MDBox py={1} pb={7}>
        <Card>
          <MDBox
            mx={2}
            mt={-4}
            py={3}
            px={2}
            sx={{
              backgroundColor: "#1E1E1E",
            }}
            variant="gradient"
            borderRadius="xl"
            coloredShadow="info"
            display="flex"
            alignItems="center"
          >
            <MDTypography fontWeight="bold" display="inline" variant="h4" color="white" mr={1}>
              Azioni e documenti
            </MDTypography>
            <MDBox component="img" src={ProjectRecording} alt="NewRequest" width="24px" my={-4} />
          </MDBox>
          <MDBox mx={3}>
            <Card
                sx={{
                    boxShadow: 0,
                    border: 1,
                    borderColor: "#D3D3D3",
                    backgroundColor: "light",
                    marginTop:4,
                    padding:2
                }}
                >

            {renderDocumentSection(
              "Documenti da firmare",
              "Caricare qui il documento firmato",
              "Sign",
              docsSign,
              newDocumentSign,
              setNewDocumentSign,
              setDocsSign
            )}
            </Card>
                        <Card
                sx={{
                    boxShadow: 0,
                    border: 1,
                    borderColor: "#D3D3D3",
                    backgroundColor: "light",
                    marginTop:4,
                    padding:2
                }}
                >


            {renderDocumentSection(
              "Adempimenti",
              "Qui trovi i pagamenti da effettuare, dopo il pagamento carica qui la ricevuta",
              "Payment",
              docsPayment,
              newDocumentPayment,
              setNewDocumentPayment,
              setDocsPayment
            )}
            </Card>
                        <Card
                sx={{
                    boxShadow: 0,
                    border: 1,
                    borderColor: "#D3D3D3",
                    backgroundColor: "light",
                    marginTop:4,
                    padding:2
                }}
                >


            {renderDocumentSection(
              "Documenti Richiesti",
              "Carica qui il documento richiesto",
              "Required",
              docsRequired,
              newDocumentRequired,
              setNewDocumentRequired,
              setDocsRequired
            )}
            </Card>
            {(loggedInUser.isAdmin || docsPermission) && (
              <MDBox
                mt={5}
                mx={-3}
                mb={-2}
                py={3}
                px={2}
                sx={{
                    borderRadius: "0 0 10px 10px",
                    position: "relative",
                    background: "linear-gradient(120deg, #000000,#191919, #00FFC4)",
                }}
                variant="gradient"
                coloredShadow="dark"
              >
                {docsPermission && loggedInUser.isAdmin && (
                  <IconButton
                    sx={{
                      color: "error",
                      position: "absolute",
                      top: { xs: "0px", sm: "8px" },
                      left: { xs: "0px", sm: "8px" },
                    }}
                    onClick={() => {
                      deleteFile("Permission", false, docsPermission, false);
                      setDocsPermission(null);
                    }}
                    color="error"
                  >
                    <DeleteIcon width="100px" />
                  </IconButton>
                )}
                <MDBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    >
                  <MDBox
                    component="img"
                    src={docsPermission?FileDownloadV2:FileUploadV2}
                    alt="permission"
                    width="80px"
                    sx={{
                      width: { xs: "50px", sm: "80px" },
                      mx: { xs: 0, sm: 4 },
                      cursor: "pointer",
                    }}
                  />
                  <MDTypography
                    fontWeight="bold"
                    display="inline"
                    variant="h1"
                    color="white"
                    sx={{
                      fontSize: { xs: "2rem", sm: "3.5rem" },
                      px: { xs: 0, sm: 0 },
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (docsPermission) {
                        downloadFile("Permission", false, docsPermission, false);
                      } else {
                        handleUploadButton("permission");
                        setStatus("Completo");
                      }
                    }}
                  >
                    {docsPermission ? "SCARICA IL TUO PERMESSO" : "UPLOAD PERMESSO"}
                  </MDTypography>
                </MDBox>
              </MDBox>
            )}
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Carica documento</DialogTitle>
        <DialogContent>
          <MDTypography fontWeight="medium" mb={2}>
            Inserisci qui la ricevuta di pagamento
          </MDTypography>

          {/* Hidden File Input */}
          <input id="upload-file" type="file" style={{ display: "none" }} onChange={handleUpload} />

          {/* Dropzone */}
          <div
            onClick={() => document.getElementById("upload-file").click()}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{
              cursor: "pointer",
              border: "8px dashed",
              borderRadius: "8px",
              padding: "100px 200px",
              textAlign: "center",
              backgroundColor: uploadedFile
                ? badgeColors.success.background
                : badgeColors.info.background,
              borderColor: dragging
                ? gradients.primary.main
                : uploadedFile
                ? gradients.success.main
                : gradients.info.main,
              transition: "border-color 0.2s ease-in-out",
            }}
          >
            {uploadedFile ? (
              <CheckIcon fontSize="large" style={{ color: gradients.success.main }} />
            ) : (
              <UploadIcon fontSize="large" style={{ color: gradients.info.main }} />
            )}
          </div>

          {/* File Name Display */}
          {uploadedFile && <p>{uploadedFile.name}</p>}
        </DialogContent>

        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenDialog(false);
              setStatus("waiting for permission");
            }}
            color="secondary"
          >
            Annulla
          </MDButton>
          <MDButton
            onClick={() => {
              handleUploadConfirm();
              saveStatus();
            }}
            color="primary"
          >
            Carica
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openValidateDialog} onClose={() => setOpenValidateDialog(false)}>
        <DialogTitle>Valida documento</DialogTitle>
        <DialogContent>
          <MDTypography fontWeight="medium" mb={2}>
            questo file è valido?
          </MDTypography>
          <MDInput
            label="Note (opzionali per invalidazione)"
            multiline
            rows={3}
            fullWidth
            value={rejectionNotes}
            onChange={(e) => setRejectionNotes(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        {validateLoading ? (
          <CircularProgress />
        ) : (
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenValidateDialog(false);
              }}
              color="secondary"
            >
              Annulla
            </MDButton>
            <MDButton onClick={() => handleValidateConfirm("-1")} color="error">
              Invalidare
            </MDButton>
            <MDButton onClick={() => handleValidateConfirm("1")} color="primary">
              Convalidare
            </MDButton>
          </DialogActions>
        )}
      </Dialog>
    </DashboardLayout>
  );
}

export default Permission;
